<template>
  <div class="logo">
    <img src="../../../assets/images/logo.png" alt=""/>
  </div>

  <h5 class="title">Let's create your new campaign:</h5>
  <div class="text">
    Get ready to supercharge your ad creative. Follow this wizard to get started on your Native journey.
  </div>

  <div class="timeline">
    <Timeline :value="steps">
      <template #marker="slotProps">
        <div class="timeline-marker" :class="{active: slotProps.item.active, done: slotProps.item.done}">
          <i class="pi pi-check" v-if="slotProps.item.done"></i>
        </div>
      </template>

      <template #content="slotProps">
        <div class="timeline-title" :class="{active: slotProps.item.active, done: slotProps.item.done}">
          {{ slotProps.item.title }}
        </div>
      </template>
    </Timeline>
  </div>

  <div class="buttons">
    <Button label="Save & Exit" class="p-button-secondary" @click="showSaveAndExitModal" />
  </div>


</template>

<script setup>
import {ref} from "vue";

const emit = defineEmits(['save'])
defineProps({
  steps: {type: Array, required: true}
});

const showSaveAndExitModal = () => emit('save');

</script>

<style lang="scss" scoped>
@import "../../../assets/sass/theme_variables";

.logo img {
  width: 99px;
  height: 32px;
}

.title {
  margin-top: toRem(50);
  font-weight: 600;
}

.text {
  line-height: 140%;
  color: $shade600;
}

::v-deep(.p-timeline) {
  .p-timeline-event-opposite {
    display: none;
  }

  .p-timeline-event {
    min-height: toRem(96);
  }
}

.timeline {
  margin-top: toRem(40);
}

.timeline-marker {
  display: flex;
  width: toRem(24);
  height: toRem(24);
  border-radius: 50%;
  background: $shade300;
  color: $bgBlocks;
  justify-content: center;
  align-items: center;

  &:not(.done):before {
    display: block;
    background: $bgBlocks;
    border-radius: 50%;
    width: toRem(6);
    height: toRem(6);
    content: '';
  }

  &.active, &.done {
    background: $primaryColor;
  }

  .pi {
    font-size: toRem(12);
  }
}

.timeline-title {
  color: $shade500;

  &.active, &.done {
    color: $textColor;
  }
}

.buttons {
  margin-top: auto;
  padding-top: 1rem;
}
</style>
